import * as React from 'react';
import { memo } from 'react';
import { withRouter } from 'react-router';

import { routes as routesConfig } from 'defs';
import { WithRouterType } from 'types/withRouter';

import Loader from 'components/atoms/Loader';

export type DeepLinkStartProgramViewPropsType = {
	id: string;
	router: {
		params: any;
		push: (path: string) => {};
	};
	hasAuthenticationLoaded: boolean;
	isAuthenticated: boolean;
	isAnamnesisDone: boolean;
	isProfileLoaded: boolean;
} & WithRouterType;

class DeepLinkStartProgramView extends React.Component<DeepLinkStartProgramViewPropsType> {
	public static displayName = 'DeepLinkStartProgramView';

	constructor(props: DeepLinkStartProgramViewPropsType) {
		super(props);

		this.handleDeepLinkProgramStart(props);
	}

	public componentDidUpdate(prevProps: DeepLinkStartProgramViewPropsType) {
		return this.handleDeepLinkProgramStart(this.props);
	}

	public handleDeepLinkProgramStart(props: DeepLinkStartProgramViewPropsType) {
		const { id, history, isProfileLoaded, isAuthenticated, isAnamnesisDone, hasAuthenticationLoaded } = props;
		const urlStartProgram = `${routesConfig.program.preview.href.replace(/:id/, id)}?startProgram=true`;

		if (!isProfileLoaded || !hasAuthenticationLoaded) {
			return;
		}

		if (!isAuthenticated) {
			history.push(routesConfig.login.indexRoute.href);
			return;
		}

		if (!isAnamnesisDone) {
			history.push(
				`${routesConfig.anamnesis.selectCoach.href}?urlStartProgram=${encodeURIComponent(urlStartProgram)}`
			);
			return;
		}

		history.push(urlStartProgram);
	}

	public render() {
		return <Loader />;
	}
}

export const DeepLinkStartProgramViewRaw = DeepLinkStartProgramView;

export default withRouter(memo(DeepLinkStartProgramView) as any);
